module.exports = __webpack_public_path__ + "assets/img/placeholder/image-portrait-251x300.jpg";